/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Draf_S3Inputs */

const en_tut_draf_s3 = /** @type {(inputs: Tut_Draf_S3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check the **Ringkasan**, **Keputusan**, **Tindak lanjut**, and **Pertanyaan terbuka** sections. **Periksa sumber asli** shows the transcript quotes behind them.`)
};

const id_tut_draf_s3 = /** @type {(inputs: Tut_Draf_S3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Periksa bagian **Ringkasan**, **Keputusan**, **Tindak lanjut**, dan **Pertanyaan terbuka**. **Periksa sumber asli** menampilkan kutipan transkrip yang mendasarinya.`)
};

/**
* | output |
* | --- |
* | "Check the **Ringkasan**, **Keputusan**, **Tindak lanjut**, and **Pertanyaan terbuka** sections. **Periksa sumber asli** shows the transcript quotes behind them." |
*
* @param {Tut_Draf_S3Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_draf_s3 = /** @type {((inputs?: Tut_Draf_S3Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Draf_S3Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_draf_s3(inputs)
	return en_tut_draf_s3(inputs)
});